import { cn } from '@/lib/utils';

interface OnlineStatusIndicatorProps {
  isOnline: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showOffline?: boolean;
}

export function OnlineStatusIndicator({ 
  isOnline, 
  size = 'md',
  className,
  showOffline = false,
}: OnlineStatusIndicatorProps) {
  if (!isOnline && !showOffline) return null;

  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  return (
    <div 
      className={cn(
        'rounded-full border-2 border-card',
        sizeClasses[size],
        isOnline 
          ? 'bg-green-500 shadow-[0_0_6px_rgba(34,197,94,0.6)]' 
          : 'bg-muted-foreground/50',
        className
      )}
      title={isOnline ? 'Đang online' : 'Offline'}
    />
  );
}

interface OnlineStatusTextProps {
  isOnline: boolean;
  className?: string;
}

export function OnlineStatusText({ isOnline, className }: OnlineStatusTextProps) {
  return (
    <span className={cn(
      'text-xs',
      isOnline ? 'text-green-500' : 'text-muted-foreground',
      className
    )}>
      {isOnline ? 'Đang online' : 'Offline'}
    </span>
  );
}
